// Translation: Reset > Landing > Form (Arabic)
export default Object.freeze({
	form: {
		actions: {
			changePassword: 'تغيير كلمة المرور',
			continue: 'إستمرار'
		},
		fields: {
			code: {
				placeholder: 'أدخل الرمز'
			},
			email: {
				placeholder: 'أدخل عنوان البريد الإلكتروني'
			},
			password: {
				options: {
					hide: {
						label: 'إخفاء كلمة المرور'
					},
					show: {
						label: 'إظهار كلمة المرور'
					}
				},
				placeholder: 'أدخل كلمة مرور جديدة'
			},
			passwordConfirmation: {
				placeholder: 'تأكيد كلمة المرور'
			}
		},
		options: {
			resendCode: {
				label: {
					idle: 'إعادة إرسال الرمز',
					success: '!تم الإرسال'
				}
			}
		},
		title: {
			codeVerification: 'تأكيد الرمز',
			information: 'معلومات',
			passwordReset: 'إعادة تعيين كلمة المرور'
		}
	}
})
